import axios from 'axios'
import { ElMessage } from 'element-plus'
import store from './utils/store.js'
import router from './route/index'

const isDevelopment = process.env.NODE_ENV === 'development';

// 创建 Axios 实例
const instance = axios.create({
    baseURL: isDevelopment ? '/api' : 'https://www.saian-iot.top', // 设置基础 URL
    // baseURL: isDevelopment ? 'http://8.137.8.105' : 'https://www.saian-iot.top', // 设置基础 URL
    timeout: 120000, // 请求超时时间
    headers: {
        'Content-Type': 'application/json', // 默认请求头
    },
});

/*
* 前置拦截，在请求头中设置token
*/
instance.interceptors.request.use(config => {
  // 可以统一设置请求头
  var token = localStorage.getItem('token')
  if (token) {
      config.headers.token = token;
      config.headers.post['Content-Type'] = 'application/json';
      config.headers.post['Data-Type'] = 'json';
  }
  return config
})
/*
* 后置拦截，处理登录过期场景
*/
instance.interceptors.response.use(
    res => {
        if (res.headers && 
            (res.headers['content-type']?.includes('application/octet-stream') || res.headers['content-type']?.includes('image_png'))
        ) {
            return res;
        }
        return res.data;
    },
    error => {
        // 根据请求状态觉得是否登录或者提示其他
        if (error.response && error.response.status === 401) {
            store.commit('logout');
            router.push({path: '/userLogin'});
            ElMessage.error('登录过期，请重新登录');
        } else if (error.response?.status === 403) {
            ElMessage.error('权限不足，无法访问');
        } else if (error.response?.status === 500) {
            ElMessage.error('服务异常[' + error.response.status+"]: " + error.response.data.retMsg);
        } else if (error.response?.status === 520) {
            ElMessage.error(error.response.data.retMsg);
        } else {
            ElMessage.error('服务异常：' + error.response?.status);
        }
        // return Promise.reject(error)
        return null;
    }
)
// 导出封装的 Axios 实例
export default instance;
